import angular from 'angular'

import { ensureIconBaseClass } from '../vd-icon/vd-icon.utility'

/**
 * Render an icon using either the Vend icon font or Font Awesome. The appropriate icon font family CSS class is applied
 * depending on the icon class provided.
 *
 * @param {String} icon The CSS class for the icon to use e.g. `fa-shopping-cart` or `vd-i-customers`
 *
 * @example
 * <vd-icon icon="fa-shopping-cart"></vd-icon>
 * <a href="/customers" vd-icon="vd-i-customers">Customers</a>
 */
angular.module('vend.ui').directive('vdIcon', function () {
  return {
    link(scope, iElement, iAttrs) {
      let iconClass = ensureIconBaseClass(iAttrs.vdIcon || iAttrs.icon)

      if (iconClass) {
        iAttrs.$addClass(iconClass)
      }

      const updateIconClass = value => {
        const newIconClass = ensureIconBaseClass(value)
        if (newIconClass !== iconClass) {
          iAttrs.$removeClass(iconClass)
          iAttrs.$addClass(newIconClass)
          iconClass = newIconClass
        }
      }

      iAttrs.$observe('icon', updateIconClass)
      iAttrs.$observe('vd-icon', updateIconClass)
    },
  }
})
